import { Model } from "pinia-orm";
import CompanyProjectRole from "./CompanyProjectRole";

export default class Role extends Model {
  static name = "Role";
  static entity = "roles";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(),
      serviceId: this.attr(""),
      createdAt: this.attr(),
      updatedAt: this.attr(),
      name: this.attr(""),
      roleType: this.attr(""),
      companyProjects: this.hasMany(CompanyProjectRole, "roleId"),
    };
  }
}
